import React, { useState } from 'react';
import { Button, Form, InputGroup, Alert } from 'react-bootstrap';
import './InlineEdit.css';

const InlineEdit = ({ value, onSave, disabled = false }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editValue, setEditValue] = useState(value);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSave = async () => {
        if (!editValue.trim() || editValue === value) {
            setIsEditing(false);
            setEditValue(value);
            setError(null);
            return;
        }

        setLoading(true);
        setError(null);
        try {
            await onSave(editValue.trim());
            setIsEditing(false);
        } catch (error) {
            setEditValue(value);
            // Extract error message from API response
            let errorMessage = 'Error al actualizar';
            if (error.response?.status === 409 && error.response?.data?.message) {
                errorMessage = error.response.data.message;
            }
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setEditValue(value);
        setIsEditing(false);
        setError(null);
    };

    if (isEditing) {
        return (
            <div>
                <InputGroup size="sm" className="inline-edit-input-group">
                    <Form.Control
                        type="text"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleSave()}
                        onKeyDown={(e) => e.key === 'Escape' && handleCancel()}
                        autoFocus
                        disabled={loading}
                        isInvalid={!!error}
                    />
                    <Button variant="success" size="sm" onClick={handleSave} disabled={loading}>
                        <i className="bi bi-check"></i>
                    </Button>
                    <Button variant="secondary" size="sm" onClick={handleCancel} disabled={loading}>
                        <i className="bi bi-x"></i>
                    </Button>
                </InputGroup>
                {error && (
                    <Alert variant="danger" className="mt-1 mb-0 p-2" style={{ fontSize: '0.8rem' }}>
                        {error}
                    </Alert>
                )}
            </div>
        );
    }

    return (
        <div className="inline-edit-container">
            <span className="inline-edit-text">{value}</span>
            {!disabled && (
                <Button
                    variant="link"
                    size="sm"
                    className="p-0 text-muted inline-edit-button"
                    onClick={() => setIsEditing(true)}
                    title="Editar nombre"
                >
                    <i className="bi bi-pencil-square" style={{ fontSize: '0.8rem' }}></i>
                </Button>
            )}
        </div>
    );
};

export default InlineEdit;